import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AiAssistComponent } from './ai-assist.component';
import { BottemplateComponent } from './bottemplate/bottemplate.component';
import { LiveSpeakAssistComponent } from './live-speak-assist/live-speak-assist.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'aiassist', component: AiAssistComponent,
        
      },
      {
        path: 'live-speak-assist', component: LiveSpeakAssistComponent
      },
    ])
  ],
  exports:[RouterModule]
})
export class AiAssistRoutingModule { }
